export const formatGrowthRate = (rate: number): string =>
  `${(rate * 100).toFixed(2)}%`
